module.exports = __webpack_public_path__ + "static/media/bvlgari-omnia-amethyste-big.d96eae5a.png";